import React, {useState, useEffect, useReducer} from 'react';
import {useParams, useHistory} from 'react-router-dom';
import axios from 'axios';
import moment from 'moment';
import useNotif from 'hooks/use-notify-hook';
import {useAlert, TYPES} from 'hooks/use-alert-hook.js';
import {useLocalStorage, useDebounce} from 'react-use';
import {answerActionReducer, attachmentsReducer} from './Utils/reducer.js';
import AnswerActionContext from './Utils/context.js';
import { ACTIONS } from './Utils/action.js';
import {
  Breadcrumb,
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
} from 'react-bootstrap';
import AnswerAction from 'views/Form/Widget/Visitation/Auditor/AnswerAction.js';


export default function Edit({children}) {

  const history = useHistory();
  const [schedule, setSchedule] = useState();
  const {actionId, employeeId} = useParams();
  const [auth] = useLocalStorage('authenticated');
  const [answerAction, dispatchAnswerAction] = useReducer(answerActionReducer, {});
  const [attachments, dispatchAttachments] = useReducer(attachmentsReducer, []);
  const fetchAction = async () => {

    try {

      const response = await axios.get(
        `${process.env.REACT_APP_API_HOST}answer-actions/${actionId}`,
        {
          headers: {Authorization: `Bearer ${auth.token}`},
          params: {expand: `
            answer.form.criteria.instrument.standard,
            pics.employee,
            actionType,
            answer.schedule.auditee.department,
            answer.schedule.auditorTeams.employee,
            answer.index,
            answer.question,
            answerActionAttachments
          `.trim()}
        }
      );

      setSchedule(response.data.answer.schedule);
      dispatchAttachments({
        type: ACTIONS.FETCH,
        payload: response.data.answerActionAttachments,
      });

      dispatchAnswerAction({
        type: ACTIONS.FETCH,
        payload: response.data
      });

    } catch (error) {
      console.log(error);
      alert(`error`);
    }
  }

  const handleClick = async (e) => {
    return history.goBack();
  }

  useEffect(() => {
    fetchAction();
  }, []);

  return (
    <AnswerActionContext.Provider value={{
      answerAction, dispatchAnswerAction,
      attachments, dispatchAttachments,
    }}>
      <Container fluid>
        <Breadcrumb>
          {/* <Breadcrumb.Item href="#pablo" onClick={(e) => e.preventDefault()}>
            Action Plan
          </Breadcrumb.Item> */}
          <Breadcrumb.Item onClick={handleClick}>
            Action Plan
          </Breadcrumb.Item>
          <Breadcrumb.Item aria-current="page" active>
            Edit
          </Breadcrumb.Item>
        </Breadcrumb>
        {answerAction ? (
          <Row>
            <Col md="12">
              <Card>
                <Card.Header>
                  <Card.Title as="h4">Action Record</Card.Title>
                </Card.Header>
                <Card.Body>
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <Form.Label>Audit</Form.Label>
                        <p>Internal audit of {answerAction?.answer?.schedule?.auditee?.department?.DEPT_NAME ?? `N/A`}</p>
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>Instrument</Form.Label>
                        <p>{answerAction?.answer?.form?.criteria?.instrument?.standard?.STANDARD_NAME ?? `N/A`} {answerAction?.answer?.form?.criteria?.instrument?.INSTRUMENT_NAME ?? `N/A`}</p>
                      </Form.Group>
                    </Col>
                    <Col md="6">
                      <Form.Group>
                        <Form.Label>Periode</Form.Label>
                        <p>{answerAction?.answer?.schedule?.START_DATE ?? `N/A`} - {answerAction?.answer?.schedule?.END_DATE ?? `N/A`}</p>
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>Auditor(s)</Form.Label>
                        <p>
                          {answerAction?.answer?.schedule?.auditorTeams?.reduce((acc, cur, idx) => {
                            if (idx === 0) return cur?.employee?.EMP_NAME;
                            return acc + `, ` + cur?.employee?.EMP_NAME;
                          }, ``) ?? `N/A`}
                        </p>
                      </Form.Group>
                    </Col>
                  </Row>
                  <hr />
                  <Row>
                    <Col md="8">
                      <Form.Group>
                        <Form.Label>Criteria</Form.Label>
                        <p>{answerAction?.answer?.form?.criteria?.CRITERIA_LABEL ?? `N/A`}</p>
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>Question</Form.Label>
                        <p>{answerAction?.answer?.question?.QUESTION_LABEL ?? `N/A`}</p>
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>auditee's answer</Form.Label>
                        <p>{
                          answerAction?.answer?.ANSWER_DESC ?
                          <div style={{whiteSpace: 'pre-wrap'}} dangerouslySetInnerHTML={{__html: answerAction?.answer?.ANSWER_DESC}} />
                          :<span className="text-danger">Not answered yet</span>
                        }</p>
                        {/* <p>{answerAction?.answer?.ANSWER_DESC ?? `N/A`}</p> */}
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>Score</Form.Label>
                        <p>{answerAction?.answer?.index?.SCORE_INDEX ?? `N/A`}</p>
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>Root Cause</Form.Label>
                        <p>{
                          answerAction?.answer?.CAUSE_DESC ?
                          <div style={{whiteSpace: 'pre-wrap'}} dangerouslySetInnerHTML={{__html: answerAction?.answer?.CAUSE_DESC}} />
                          :<span className="text-danger">N/A</span>
                        }</p>
                        {/* <p>{answerAction?.answer?.CAUSE_DESC ?? `N/A`}</p> */}
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>Action Plan</Form.Label>
                        <p>{
                          answerAction?.PLAN_DESC ?
                          <div style={{whiteSpace: 'pre-wrap'}} dangerouslySetInnerHTML={{__html: answerAction?.PLAN_DESC}} />
                          :<span className="text-danger">N/A</span>
                        }</p>
                        {/* <p>{answerAction?.PLAN_DESC ?? `N/A`}</p> */}
                      </Form.Group>
                    </Col>
                    <Col md="4">
                      <Form.Group>
                        <Form.Label>Status</Form.Label>
                        <p>{answerAction?.ANSWER_ACTION_STATUS ?? `N/A`}</p>
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>Due Date</Form.Label>
                        <p>{moment(answerAction?.DUE_DATE, 'DD-MMM-YYYY').format('DD/MM/YYYY') ?? `N/A`}</p>
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>PIC</Form.Label>
                        <p>
                          {answerAction?.pics?.reduce((acc, cur, idx) => {
                            if (idx === 0) return cur?.employee?.EMP_NAME;
                            return acc + `, ` + cur?.employee?.EMP_NAME;
                          }, '')}
                        </p>
                      </Form.Group>
                    </Col>
                  </Row>
                  <hr />
                  {children}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        ) : <p>Now Loading...</p>}
      </Container>
    </AnswerActionContext.Provider>
  );
}